function getUrlParameter(sParam: string): null|boolean|string {
    const searchParamters = new URLSearchParams(window.location.search);
    const value = searchParamters.get(sParam);
    if (value === null)
        return null;
    if (value === "")
        return true;
    return value;
}

function show_login(){
    document.querySelectorAll<HTMLElement>(".only-register").forEach((element) => {
        element.hidden = true;
    });
    document.querySelectorAll<HTMLElement>(".only-login").forEach((element) => {
        element.hidden = false;
    });
}

function show_register(){
    document.querySelectorAll<HTMLElement>(".only-login").forEach((element) => {
        element.hidden = true;
    });
    document.querySelectorAll<HTMLElement>(".only-register").forEach((element) => {
        element.hidden = false;
    });
}

document.addEventListener("DOMContentLoaded", () => {
    if(getUrlParameter('login') == "1"){
        show_login();
    }

    document.querySelectorAll(".entry-switcher").forEach((entrySwitcher) => {
        entrySwitcher.addEventListener("click", (e) => {
            const target = e.target;
            if (!(target instanceof Element)) return;

            if (target.closest(".switch-login")) {
                e.preventDefault();
                show_login();
            }

            if (target.closest(".switch-register")) {
                e.preventDefault();
                show_register();
            }
        });
    });
});
